import React, { memo } from "react";
import { Box, Text } from "@storyofams/react-ui";

import { IngredientsTable } from "./IngredientsTable";

export const IngredientsTab = memo(
  ({ products, id }: any) => {
    const regularProducts = products.filter((item) => !item?.optional);
    const optionalProducts = products.filter((item) => item?.optional);
    return (
      <Box mt={[0, 3]}>
        <Text
          display={["none", "block"]}
          fontFamily={"DINPro"}
          fontWeight={700}
          lineHeight={"28.8px"}
          fontSize={"24px"}
        >
          Ingrediënten
        </Text>
        {!!regularProducts.length && (
          <IngredientsTable products={regularProducts} />
        )}
        {optionalProducts && !!optionalProducts.length && (
          <>
            <Text
              display={["block"]}
              fontFamily={"DINPro"}
              fontWeight={700}
              mt={[2, 2]}
              lineHeight={["20px", "28.8px"]}
              fontSize={["18px", "24px"]}
            >
              Optionele ingrediënten
            </Text>
            <IngredientsTable products={optionalProducts} isOptional />
          </>
        )}
      </Box>
    );
  },
  (prev, next) => prev.id === next.id
);
